import _ from "lodash";
import { GState } from ".";

class ResponsiveX {

  /**
   * 
   * @param {Object.<number, Func>} screen 
   * @returns 
   */
  static Split(screen){
    let screenWidth = GState.innerWidth ?? window.innerWidth;   
    let _cur = _.findLast(screen, (o, i) => i <= screenWidth);
    return _cur?.() ?? null;
  }

  static RefMin(origin, refWidth){
    if(refWidth){
      return Math.max(origin, origin * (window.innerWidth / refWidth));
    }
    return origin;
  }

  static RefMax(origin, refWidth){
    if(refWidth){
      return Math.min(origin, origin * (window.innerWidth / refWidth));
    }
    return origin;
  }

  static Ratio(origin, refWidth){
    if(refWidth){
      return origin * (window.innerWidth / refWidth);
    }
    return origin;
  }

}

export default ResponsiveX;